import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { ExtractItem } from 'site-modules/personalized-search/components/extract/extract-item';
import { EXTRACT_CREATIVE_ID } from 'site-modules/shared/constants/personalized-search/personalized-search';

export function Extract({ componentParams: extracts, onRendered = noop }) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <section className="extract" data-tracking-parent={EXTRACT_CREATIVE_ID}>
      <div className="my-2">
        <h3 className="size-20 fw-bold mb-1">What you should know</h3>
        <ul className="list-unstyled m-0">
          {extracts.map(({ answer, question }, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <ExtractItem key={idx} answer={answer} question={question} isInitiallyExpanded={idx === 0} />
          ))}
        </ul>
      </div>
    </section>
  );
}

Extract.propTypes = {
  componentParams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onRendered: PropTypes.func,
};
